<template>
  <DialogContainer :show="isVisible" @close="closeSettingsMainPage">
    <!-- 个人中心操作会有埋点跟踪，后续新增操作需要同步新增埋点 -->
    <div class="setting-modal">
      <!-- TODO   我们需要一个把主界面上的这几个浮窗元素统一管理的实现，由它控制只能有一个元素显示，而不是这种子组件反向控制父组件。-->
      <div v-if="isFileManager">
        <div data-test="item-file-manager-guide" class="setting-item margin-divide" @click="openUseGuideModal">
          {{ $t('owork_base.user_guide') }}
        </div>
        <div class="h5-divider"></div>
        <!-- <div data-test="item-privacy-policy" class="setting-item margin-divide" @click="openPrivacyPolicyModal">
          {{ $t('owork_base.user_policy') }}
        </div>
        <div class="h5-divider"></div> -->
        <a
          data-test="item-owork-questionnaire"
          class="setting-item setting-item-block"
          @click="
            ($event) => {
              personalCenterOperationTrack('questionnaire_feedback')
              openInNewWindow(QuestionnaireFeedbackPageUrl)
            }
          "
          >{{ $t('owork_base.questionnaire_feedback') }}</a
        >
        <div
          v-if="showDownload"
          class="setting-item setting-mac-download-item"
          @click="
            () => {
              personalCenterOperationTrack('download_from_owork')
              track({
                eventId: 'download_from_owork',
              })
            }
          "
        >
          <a class="setting-item-block" :href="DOWNLOAD_MAC_APP_URL">{{ $t('owork_base.download_the_mac_client') }}</a>
        </div>
        <div class="divider"></div>
      </div>
      <div v-else>
        <div v-if="currentDomain === DOMAIN_OPPO || currentDomain === DOMAIN_HEYTAP">
          <a
            v-if="currentDomain === DOMAIN_OPPO"
            data-test="item-feedback"
            class="setting-item setting-item-block margin-divide"
            @click="() => openInNewWindow(ForumFeedbackPageUrl)"
            >{{ $t('owork_base.forum_feedback') }}</a
          >
          <div v-if="currentDomain === DOMAIN_OPPO" class="divider"></div>
          <div data-test="item-online-service" class="setting-item" @click="openOnlineServiceAgentPage">
            {{ $t('owork_base.online_customer_service') }}
          </div>
          <div class="divider"></div>
          <a
            data-test="item-back-to-old-sticky-notes"
            class="setting-item setting-item-block"
            :href="OLD_VERSION_PATH"
            @click="($event) => personalCenterOperationTrack('back_to_old_version')"
            >{{ $t('owork_base.switch_to_the_old_version') }}</a
          >
          <div class="divider"></div>
        </div>
      </div>
      <div class="setting-item-logout">
        <div class="h5-user-name setting-item">{{ userInfo?.userName }}</div>
        <div data-test="item-logout" class="setting-item logout-item" @click="exit">
          {{ $t('owork_base.exit_account') }}
        </div>
        <div class="setting-item h5-logout-item" @click="exit">
          {{ $t('owork_base.log_out') }}
        </div>
      </div>
    </div>
  </DialogContainer>
  <UseGuide v-if="useGuideModal" @cancel-use-guide="cancelUseGuide" />
  <PrivacyPolicyModel v-if="privacyPolicyModal" @cancel-privacy-policy="cancelPrivacyPolicy" />
  <Logout v-if="exitVisible" :visible="exitVisible" @cancel="cancelExitM" />
</template>

<script lang="ts" setup>
  import { ref, onMounted } from 'vue'
  import DialogContainer from '../dialog/DialogContainer.vue'
  import UseGuide from './UseGuide/UseGuide.vue'
  import PrivacyPolicyModel from './privacyPolicy/PrivacyPolicyModel.vue'
  import Logout from './LogoutPopper.vue'
  import { useOtrack } from '@/core/compositions/Otrack'
  import { useElectron } from '@core/compositions/Electron'
  import { PATH_SEPARATOR } from '@core/Constants'
  import { TrackEventMap } from '@/core/TrackConstants'
  import { isEmpty } from 'lodash'
  import { getDomain } from '@/BuildUtils'
  import { useSharedActiveMenuItem } from '@core/compositions/ActiveMenuItem'
  import { MainHeaderItems, useSharedActiveMainHeaderItem } from '@/core/compositions/ActiveMainHeaderItem'
  import { isMac } from '@/core/Utils'
  import { useI18n } from 'vue-i18n'
  import { INSTANCE as UserInfoManager } from '@/core/userInfo/UserInfoManager'
  import type { UserInfo } from '@/netadapters/CloudAdapter'

  const { t } = useI18n()
  const { updateCurrentSelectedItem } = useSharedActiveMainHeaderItem()

  const { isFileManager, currentAppTrackName } = useSharedActiveMenuItem()

  const OLD_VERSION = 'old'
  const OLD_VERSION_PATH = Array.of('', OLD_VERSION, '').join(PATH_SEPARATOR)
  const DOMAIN_OPPO = 'oppo.com'
  const DOMAIN_HEYTAP = 'heytap.com'
  const QuestionnaireFeedbackPageUrl = 'https://wj.heytap.com/r/o65IdveB/page/p-tXnV7'

  const DOWNLOAD_MAC_APP_URL = import.meta.env.VITE_PC_DOWNLOAD_URL
  const ForumFeedbackPageUrl = 'https://bbs.coloros.com/forum.php'
  const HeytapOnlineServiceAgentPageUrl =
    'https://chat.heytap.com/chat/h5/v2/index.html?sysnum=9f06d616a05a43a9a50421f5f0982e4d&channelid=24'
  const OppoOnlineServiceAgentPageUrl =
    'https://chat.oppo.com/chat/h5/v2/index.html?sysnum=9f06d616a05a43a9a50421f5f0982e4d&channelid=53'
  const isVisible = ref<boolean>(true)
  const useGuideModal = ref<boolean>(false)
  const privacyPolicyModal = ref<boolean>(false)
  const exitVisible = ref<boolean>(false)
  const currentDomain = ref<string | undefined>(getDomain(new URL(window.location.href).hostname))
  const userInfo = ref<UserInfo>()

  const { track } = useOtrack()

  const personalCenterOperationTrack = (operation: string) => {
    if (isEmpty(currentAppTrackName.value)) return

    track(
      {
        eventId: TrackEventMap.PERSONAL_CENTER_OPERATION,
      },
      {
        current_app_name: currentAppTrackName.value,
        operation,
      }
    )
  }

  const openUseGuideModal = () => {
    useGuideModal.value = true

    track({
      eventId: TrackEventMap.ENTERED_FAQ,
    })
    personalCenterOperationTrack('open_use_guide')
  }

  const cancelUseGuide = (val: boolean) => {
    useGuideModal.value = val
  }

  const openPrivacyPolicyModal = () => {
    privacyPolicyModal.value = true
    personalCenterOperationTrack('open_privacy_policy')
  }

  const cancelPrivacyPolicy = (val: boolean) => {
    privacyPolicyModal.value = val
  }

  const exit = () => {
    track({
      eventId: TrackEventMap.LOG_OUT,
    })
    personalCenterOperationTrack('log_out')
    exitVisible.value = true
  }

  const cancelExitM = () => {
    exitVisible.value = false
  }

  const closeSettingsMainPage = () => {
    updateCurrentSelectedItem(MainHeaderItems.SETTINGS_MAIN_PAGE)
  }

  const openOnlineServiceAgentPage = () => {
    if (currentDomain.value !== DOMAIN_OPPO && currentDomain.value !== DOMAIN_HEYTAP) return

    window.open(currentDomain.value === DOMAIN_OPPO ? OppoOnlineServiceAgentPageUrl : HeytapOnlineServiceAgentPageUrl)
  }
  const pcEnv = useElectron()

  const isInStandardWebEnv = pcEnv === undefined
  const showDownload = isMac() && isInStandardWebEnv

  const openInNewWindow = (pageUrl: string) => {
    if (isInStandardWebEnv) {
      window.open(pageUrl, '_blank')
    } else {
      pcEnv.openInNewWindow(pageUrl, { title: t('owork_base.owork') })
    }
  }

  onMounted(async () => {
    userInfo.value = await UserInfoManager.getUserInfo()
  })
</script>
<style lang="stylus" scoped>

  .setting-modal
    position absolute
    right 16px
    top 45.5px
    width 169px
    background #ffffff
    box-sizing border-box
    border 1px solid #ebecf0
    box-shadow 0px 20px 36px rgba(16, 22, 82, 0.06)
    border-radius 12px
    .divider
    .h5-divider
      rect(auto, 1px)
      margin 0 16px
      background-color rgba(0,0,0,0.06)
    .setting-item
      font-size 14px
      title()
      cursor pointer
      min-height 20px
      line-height 20px
      box-sizing content-box
      padding 14px 16px
      &:hover
        background #f8f9fb
        &:first-child
          border-top-left-radius 12px
          border-top-right-radius 12px
        &:last-child
          border-bottom-left-radius 12px
          border-bottom-right-radius 12px
    .setting-item-block
      display block
      color default_color !important

  @import '../styles/h5Adaptive/SettingsMainPage.styl'
</style>
